import script from "./dealEditModal.vue?vue&type=script&lang=jsx&setup=true"
export * from "./dealEditModal.vue?vue&type=script&lang=jsx&setup=true"

import "./dealEditModal.vue?vue&type=style&index=0&id=e356c07c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e356c07c"]])

export default __exports__